import { AbstractControl, ValidationErrors } from '@angular/forms';

export function matchPasswordValidator(
  passwordField: string,
  confirmField: string
) {
  return (group: AbstractControl): ValidationErrors | null => {
    const password = group.get(passwordField);
    const confirm = group.get(confirmField);

    if (!password || !confirm) return null;

    const passwordValue = password.value;
    const confirmValue = confirm.value;

    // Si alguno está vacío, no marcamos aún
    if (!confirmValue) {
      if (confirm.hasError('passwordMismatch')) {
        const { passwordMismatch, ...rest } = confirm.errors || {};
        confirm.setErrors(Object.keys(rest).length ? rest : null);
      }
      return null;
    }

    if (passwordValue !== confirmValue) {
      confirm.setErrors({
        ...(confirm.errors || {}),
        passwordMismatch: true,
      });
      return { passwordMismatch: true };
    }

    // Si coinciden, limpiamos solo ese error
    if (confirm.hasError('passwordMismatch')) {
      const { passwordMismatch, ...rest } = confirm.errors || {};
      confirm.setErrors(Object.keys(rest).length ? rest : null);
    }

    return null;
  };
}
